// extracted by mini-css-extract-plugin
var _1 = "button_arrow__bc6r7";
var _2 = "#4c4c4c";
var _3 = "button_button__fufkk";
var _4 = "button_close__xnyzi";
var _5 = "button_content__r+mwy";
var _6 = "640px";
var _7 = "790px";
var _8 = "#057676";
var _9 = "button_disabled__ssthh";
var _a = "#434343";
var _b = "button_icon__2ebwu";
var _c = "79px";
var _d = "110px";
var _e = "72px";
var _f = "button_minimal__g4kq7";
var _10 = "665px";
var _11 = "button_outline__wyaac";
var _12 = "button_primary__fcz2d";
var _13 = "teal";
var _14 = "2";
var _15 = "#cdd3dc";
export { _1 as "arrow", _2 as "body", _3 as "button", _4 as "close", _5 as "content", _6 as "controlsMobileWidth", _7 as "controlsStackedWidth", _8 as "darkTeal", _9 as "disabled", _a as "headline", _b as "icon", _c as "menuHeight", _d as "menuHeightLarge", _e as "menuHeightMobile", _f as "minimal", _10 as "modalMobileWidth", _11 as "outline", _12 as "primary", _13 as "teal", _14 as "timelineStrokeWidth", _15 as "timelineTrackColor" }
